export const REVIEW_STORAGE_KEY = 'bfa-quercus-character-review:v2'
export const LEGACY_REVIEW_STORAGE_KEY = 'bfa-quercus-character-review:v1'
export const REVIEW_RECOVERY_KEY = 'bfa-quercus-character-review:incompatible-backup'
export const REVIEW_STORAGE_VERSION = 2
export const REVIEW_EXPORT_TYPE = 'quercus-character-review'
export const REVIEW_EXPORT_VERSION = '1.1.0'

export const REVIEW_DECISIONS = [
  ['accept_as_drafted', 'Accept as drafted'],
  ['accept_with_wording_correction', 'Accept with wording correction'],
  ['revise_character_concept', 'Revise character concept'],
  ['revise_state_boundaries', 'Revise state boundaries'],
  ['revise_measurement_protocol', 'Revise measurement protocol'],
  ['keep_confirmatory_only', 'Keep as confirmatory only'],
  ['keep_contextual_only', 'Keep as contextual only'],
  ['exclude_from_scoring', 'Exclude from identification scoring'],
  ['defer_further_evidence', 'Defer pending further evidence'],
  ['reject_from_pilot', 'Reject from the pilot'],
]

export const NOTE_FIELDS = [
  'revised_preferred_label',
  'revised_short_clarification',
  'atomicity_comments',
  'state_boundary_comments',
  'measurement_comments',
  'variation_comments',
  'diagnostic_role_decision',
  'illustration_comments',
  'additional_source_requirement',
  'general_reviewer_note',
]

export const PROPOSED_CHANGE_TYPES = {
  character_wording: { entity: 'character', fields: ['preferred_label', 'definition', 'help_text'] },
  character_state_wording: { entity: 'character_state', fields: ['preferred_label', 'definition'] },
  assertion_variability: { entity: 'assertion', fields: ['biological_variability'] },
  observation_method_recommendation: { entity: 'observation_method', fields: ['recommendation'] },
  measurement_protocol_recommendation: { entity: 'measurement_protocol', fields: ['recommendation'] },
  diagnostic_role_recommendation: { entity: 'character', fields: ['diagnostic_role'] },
  illustration_requirement_recommendation: { entity: 'illustration_requirement', fields: ['recommendation'] },
}

export function emptyProposedChange(characterId = '') {
  return { change_type: 'character_wording', target_entity: 'character', target_id: characterId, field: 'preferred_label', proposed_value: '', rationale: '' }
}

export function emptyReview() {
  return { ...Object.fromEntries(['decision', ...NOTE_FIELDS].map((field) => [field, ''])), proposed_changes: [] }
}
